import { uploadBaseUrl, maxFileSize } from "../app.json";
import axios from "axios";
class ImageProvider {
	/**
	 * Uploads file to server
	 * @param {string} id current authenticated user id
	 * @param {File} file file to upload
	 */
	async Upload(id, file) {
		if (id && file) {
			// Check file size
			if (file.size > maxFileSize)
				throw new Error(`${file.name} is too large!`);
			// new instance of form data
			let fd = new FormData();
			fd.append("file", file);
			fd.append("id", id);

			// Fetch
			try {
				const cb = await axios.post(uploadBaseUrl, fd);
				if (cb.status === 200) {
					return cb.data;
				}
				throw new Error("An error occured!");
			} catch (error) {
				throw error;
			}
		} else {
			throw new Error("File or/and identifier not found!");
		}
	}
}
export const imageProvider = new ImageProvider();
